"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchStyles = void 0;
// No idea the best way to do this -- for now just loading the styles into a file at build time,
// and requiring them. This way we can use CSS (and maybe even SCSS) while still having the
// in-memory strings to use.
const styles_json_1 = __importDefault(require("./styles.json"));
const fetchStyles = (style, version = 'v1') => {
    return styles_json_1.default[''][style][`${version}.css`];
};
exports.fetchStyles = fetchStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3N0eWxlcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnR0FBZ0c7QUFDaEcsMkZBQTJGO0FBQzNGLDRCQUE0QjtBQUM1QixnRUFBa0Q7QUFNM0MsTUFBTSxXQUFXLEdBQUcsQ0FBQyxLQUFxQixFQUFFLE9BQU8sR0FBRyxJQUFJLEVBQVUsRUFBRTtJQUMzRSxPQUFRLHFCQUFNLENBQUMsRUFBRSxDQUFjLENBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxPQUFPLE1BQU0sQ0FBQyxDQUFBO0FBQzFELENBQUMsQ0FBQztBQUZXLFFBQUEsV0FBVyxlQUV0QiJ9